export const hex2rgba = (hex: any, alpha = 1, blackOrWhite = false) => {
  const [r, g, b] = hex.match(/\w\w/g).map((x: any) => parseInt(x, 16));
  if (!blackOrWhite) return `rgba(${r},${g},${b},${alpha})`;
  return `${r}${g}${b}`;
};
